import { render, staticRenderFns } from "./HealthProfessionalProfile.vue?vue&type=template&id=456d4474&"
import script from "./HealthProfessionalProfile.vue?vue&type=script&lang=js&"
export * from "./HealthProfessionalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports